export const EMPTY_FILE_UPLOAD_ERROR_MESSAGE = 'Upload failed. File is empty';